import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import MonitoringMobile from "components/MonitoringMobile/MonitoringMobile";

import * as mobileReducer from "containers/MonitoringMobile/reducer";
import * as viewReducer from "containers/View/reducer";

class MonitoringMobileContainer extends React.Component {
  componentDidMount() {
    this.props.updateViewingMobile(true);
    this.props.loadMonitorData();
  }

  componentWillUnmount() {
    this.props.updateViewingMobile(false);
  }

  render() {
    return <MonitoringMobile {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    updateDisplayType: (val) => dispatch(mobileReducer.updateDisplayType(val)),
    updateViewingMobile: (val) => dispatch(mobileReducer.updateViewingMobile(val)),
    loadMonitorData: () => dispatch(mobileReducer.loadMonitorData()),
    getMontiors: (projectIDs, warningsGroup) => dispatch(mobileReducer.getMontiors(projectIDs, warningsGroup))
  };
};

const mapStateToProps = (state, ownProps) => {
  const pathname = ownProps.location.pathname;
  const id = pathname.substr(pathname.lastIndexOf("/"));

  const projectData = viewReducer.getProjects(state);
  const projectIDs = projectData.map((project) => project.id);

  return {
    displayType: mobileReducer.getDisplayType(state),
    warningsGroup: mobileReducer.getMonitorWarnings(state, projectIDs),
    profits: mobileReducer.getMonitorProfits(state, projectIDs),
    projectData: projectData,
    projectIDs: projectIDs,
    loadStatus: mobileReducer.getLoadStatus(state)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(MonitoringMobileContainer);
